import React from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaUser, FaArrowRight, FaTag } from 'react-icons/fa';
import { getFeaturedPost, getRegularPosts, getCategories } from './blogData';
import './Blog.css';
import { Helmet } from 'react-helmet';

const Blog = () => {
  const featuredPost = getFeaturedPost();
  const posts = getRegularPosts();
  const categories = getCategories();

  return (
    <>
      <Helmet>
        <title>Blogs</title>
      </Helmet>
      <div className="blog-page">
        <div className="page-header">
          <div className="container">
            <h1>Blog</h1>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Blog</span>
            </div>
          </div>
        </div>

        <section className="blog-featured section">
          <div className="container">
            <Link to={`/blog/${featuredPost.id}`} className="featured-post">
              <div className="featured-image">
                <img src={featuredPost.image} alt={featuredPost.title} />
                <span className="featured-badge">Featured</span>
              </div>
              <div className="featured-content">
                <span className="post-category">{featuredPost.category}</span>
                <h2>{featuredPost.title}</h2>
                <p>{featuredPost.excerpt}</p>
                <div className="post-meta">
                  <span><FaUser /> {featuredPost.author}</span>
                  <span><FaCalendarAlt /> {featuredPost.date}</span>
                </div>
                <span className="read-more">
                  Read Full Article <FaArrowRight />
                </span>
              </div>
            </Link>
          </div>
        </section>

        <section className="blog-main section bg-light">
          <div className="container">
            <div className="blog-layout">
              <div className="blog-content">
                <h3 className="blog-section-title">Latest Articles</h3>
                <div className="blog-grid">
                  {posts.map((post) => (
                    <Link key={post.id} to={`/blog/${post.id}`} className="blog-card">
                      <div className="blog-card-image">
                        <img src={post.image} alt={post.title} />
                        <span className="post-category">{post.category}</span>
                      </div>
                      <div className="blog-card-content">
                        <h4>{post.title}</h4>
                        <p>{post.excerpt}</p>
                        <div className="post-meta">
                          <span><FaUser /> {post.author}</span>
                          <span><FaCalendarAlt /> {post.date}</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>

              <aside className="blog-sidebar">
                {/* <div className="sidebar-widget"> */}
                  {/* <h4>Categories</h4> */}
                  {/* <ul className="category-list">
                    {categories.map((category, index) => (
                      <li key={index}>
                        <Link to="/blog">
                          <FaTag /> {category}
                        </Link>
                      </li>
                    ))}
                  </ul> */}
                {/* </div> */}

                {/* <div className="sidebar-widget">
                  <h4>Subscribe to Newsletter</h4>
                  <p>Get the latest tips and news directly in your inbox.</p>
                  <form className="subscribe-form">
                    <input type="email" placeholder="Your email address" />
                    <button type="submit" className="btn btn-primary">
                      Subscribe
                    </button>
                  </form>
                </div> */}

                <div className="sidebar-widget cta-widget">
                  <h4>Ready to Start Training?</h4>
                  <p>Join Imperial Badminton Academy and take your game to the next level.</p>
                  <Link to="/contact" className="btn btn-accent">
                    Join Now <FaArrowRight />
                  </Link>
                </div>
              </aside>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Blog;
